import { useEffect, useState } from "react"

interface ProgressBarProps {
    current: number
    of: number
}

function ProgressBar(props: ProgressBarProps) {
    const [percentage, setPercentage] = useState<string>("0%")

    useEffect(() => {
        const proportion = (props.current / props.of) * 100
        setPercentage(`${Math.floor(proportion)}%`)
    }, [props.current])

    return (
        <div className={"bg-neutral-400 w-full h-2"}>
            <div
                style={{
                    width: percentage
                }}
                className={"bg-blue-600 h-2"}
            />
        </div>
    )
}

export default ProgressBar
